import { RouterParamType } from "@/model/navModel";
import React, { FC, useState } from "react";
import { TableBox } from "./TableBox";


export const AuditDetail: FC<RouterParamType> = (detailsInfo) => {

    return (
        <TableBox {...detailsInfo} />
    )
}